import { TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
var IndependienteComponent = /** @class */ (function () {
    function IndependienteComponent(fb, _userService, rutValidator, dialog, spinner) {
        this.fb = fb;
        this._userService = _userService;
        this.rutValidator = rutValidator;
        this.dialog = dialog;
        this.spinner = spinner;
        this.rows = [];
        this.matcher = new FormService();
        this.nombreComuna = new FormControl('', [Validators.required]);
        this.options = [];
        this.selectedInd = null;
        this.rut_ind = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        });
        if (!JSON.parse(localStorage.getItem("independiente"))) {
            localStorage.setItem("independiente", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("independiente"));
        }
        this.invalidRut = true;
        this.independiente = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' };
    }
    IndependienteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getComunas();
        console.log(this.nombreComuna);
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(startWith(''), map(function (value) {
            return _this._filter(value);
        }));
    };
    IndependienteComponent.prototype._filter = function (value) {
        var filterValue = value.toLowerCase();
        return this.options.filter(function (option) { return option.toLowerCase().includes(filterValue); });
    };
    IndependienteComponent.prototype.get_independiente = function (rut) {
        var _this = this;
        var rut_orig = rut;
        var dv;
        if (rut.includes("-")) {
            var fullRut = rut.split("-");
            rut = fullRut[0];
            dv = fullRut[1];
        }
        else {
            dv = rut;
            rut = rut.toString();
            rut = rut.substring(0, rut.length - 1);
            dv = dv.slice(-1);
        }
        console.log("este es el rut limpio", rut);
        if (rut >= 50000000) {
            this.isNatural = false;
        }
        else {
            this.isNatural = true;
        }
        this.spinner.show();
        this.cleanData();
        this._userService.getIndependiente(rut_orig).subscribe(function (response) {
            if (response.message) {
                _this.independiente.rut = rut ? rut : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
            else {
                _this.independiente.rut = response.rut ? response.rut : '';
                _this.independiente.nombre = response.nombre ? response.nombre : '';
                _this.independiente.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                _this.independiente.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                _this.independiente.direccion = response.direccion ? response.direccion : '';
                _this.independiente.direccion_num = response.direccion_num ? response.direccion_num : '';
                _this.independiente.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                _this.independiente.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                _this.independiente.comuna = response.comuna ? response.comuna : '';
                _this.independiente.fono = response.fono ? response.fono : '';
                _this.independiente.fax = response.fax ? response.fax : '';
                _this.independiente.mail = response.mail ? response.mail : '';
                _this.independiente.patente = response.patente ? response.patente : '';
                _this.independiente.registro = response.registro ? response.registro : '';
                _this.independiente.categoria = response.categoria ? response.categoria : '';
                _this.independiente.recordId = response.recordId ? response.recordId : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    IndependienteComponent.prototype.cleanData = function () {
        this.independiente = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' };
        this.rut_ind.reset();
    };
    IndependienteComponent.prototype.update_independiente = function (rut, id) {
        this.get_independiente(rut);
        this.selectedInd = id;
    };
    IndependienteComponent.prototype.saveIndependiente = function () {
        var _this = this;
        window.scroll(0, 0);
        //por si escriben un rut que ya esté ingresado
        for (var x = 0; x < this.rows.length; x++) {
            if (this.independiente.rut == this.rows[x].rut) {
                this.delete_independiente(x);
            }
        }
        //elimina fila cuando la editan
        /*if (this.selectedInd != null) {
            this.delete_independiente(this.selectedInd);
            this.selectedInd = null;
        }*/
        this.spinner.show();
        this._userService.saveIndependiente(this.independiente).subscribe(function (response) {
            _this.spinner.hide();
            console.log(response);
            if (response.update || response.save) {
                $("#ind_modal").modal("hide");
                _this.actualRow = localStorage.getItem("independiente");
                _this.rows = JSON.parse(_this.actualRow);
                _this.rows = _this.rows.concat({
                    rut: _this.independiente.rut,
                    nombre: _this.independiente.nombre,
                    apellido_mat: _this.independiente.apellido_mat,
                    apellido_pat: _this.independiente.apellido_pat,
                    direccion: _this.independiente.direccion,
                    direccion_num: _this.independiente.direccion_num,
                    direccion_complemento: _this.independiente.direccion_complemento,
                    direccion_completa: _this.independiente.direccion_completa,
                    comuna: _this.independiente.comuna,
                    fono: _this.independiente.fono,
                    fax: _this.independiente.fax,
                    mail: _this.independiente.mail,
                    patente: _this.independiente.patente,
                    registro: _this.independiente.registro,
                    categoria: _this.independiente.categoria
                });
                localStorage.setItem("independiente", JSON.stringify(_this.rows));
                _this.independiente = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', categoria: '', registro: '', recordId: '' };
                _this.rut_ind.reset();
                _this.dialog.closeAll();
            }
        }, function (error) {
            _this.spinner.hide();
            console.log(error);
        });
    };
    IndependienteComponent.prototype.delete_independiente = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("independiente", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('independiente'));
            }
        }
    };
    IndependienteComponent.prototype.getComunas = function () {
        var _this = this;
        this._userService.getComunas().subscribe(function (res) {
            //console.log('res', res);
            for (var i = 0; i < res.length; i++) {
                _this.options.push(res[i].fieldData.COM_Nombre);
            }
            _this.filteredOptions = _this.nombreComuna.valueChanges
                .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
        }, function (error) {
            console.log(error);
        });
    };
    return IndependienteComponent;
}());
export { IndependienteComponent };
